import { render, staticRenderFns } from "./_headers.vue?vue&type=template&id=1f2f4602"
import script from "./_headers.vue?vue&type=script&lang=js"
export * from "./_headers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports